module.exports = "pegasus_template/assets/background-patterns/tech_theme.gif";